import { render } from "./extendPayment.vue?vue&type=template&id=221a3f9d"
import script from "./extendPayment.vue?vue&type=script&lang=js"
export * from "./extendPayment.vue?vue&type=script&lang=js"

import "./extendPayment.vue?vue&type=style&index=0&id=221a3f9d&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__